"use strict";

exports.__esModule = true;
exports.DataTableDataProvider = void 0;
var _react = _interopRequireDefault(require("react"));
var _ReportingPeriodContext = require("../../Time/ReportingPeriod/ReportingPeriodContext");
var _URLFilter = require("../../Core/URLFilter");
var _EventTimelineController = require("../../EventTimeline/EventTimelineController");
var _DeviceContext = require("../../Device/DeviceContext");
var _Core = require("../../Core");
var _DeviceMTCDataQueryController = require("../../Device/DeviceMTCDataQueryController");
var _TimePeriodController = require("../../Time/TimePeriodController");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DEFAULT_PAGINATION_OBJECT = {
  number: 0,
  size: 20,
  totalPages: 1,
  numberOfElements: 0,
  sort: []
};

/**
 * Handle multi and single device list reports.
 * @param multiDeviceList
 * @param singleDeviceList
 * @returns {*}
 */
var getSelectedDeviceList = function getSelectedDeviceList(multiDeviceList, singleDeviceList) {
  var device = multiDeviceList;
  if (!Array.isArray(device)) {
    device = [device];
  }
  if (singleDeviceList) {
    device = [singleDeviceList.uuid];
  }
  return device;
};
function getEventStates(asyncLoaderProps, dataSource, children) {
  var fetching = asyncLoaderProps.fetching,
    error = asyncLoaderProps.error,
    data = asyncLoaderProps.data,
    reload = asyncLoaderProps.reload;
  var content = data && data[dataSource] ? data[dataSource] : [];
  if (content == null) {
    return /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
      error: new Error("No content found for " + dataSource)
    });
  }

  // Pull out the server response pagination props
  var serverPagination = data && data.pagination ? data.pagination : DEFAULT_PAGINATION_OBJECT;
  return children({
    content: content,
    reload: reload,
    serverPagination: serverPagination,
    fetching: fetching,
    error: error
  });
}
var EventDataFetcher = function EventDataFetcher(props) {
  var dataRange = props.dataRange,
    eventSource = props.eventSource,
    pagination = props.pagination,
    onData = props.onData,
    children = props.children;
  var selectedDevice = _react["default"].useContext(_DeviceContext.DeviceContext);
  var urlFilter = _react["default"].useContext(_URLFilter.URLFilterContext);
  var reportingPeriod = _react["default"].useContext(_ReportingPeriodContext.ReportingPeriodContext);
  var selection = _react["default"].useContext(_Core.SelectionContext);
  var selectedDeviceList = getSelectedDeviceList(urlFilter.filters.device, selectedDevice);
  var timePeriod = (0, _TimePeriodController.getTimePeriod)(reportingPeriod, selection, dataRange);
  return /*#__PURE__*/_react["default"].createElement(_EventTimelineController.EventTimelineController, {
    searchTerm: reportingPeriod.term,
    sortOrder: pagination.sort,
    pagination: pagination,
    start: new Date(timePeriod.interval.startMillis).toISOString(),
    end: new Date(timePeriod.interval.endMillis).toISOString(),
    deviceList: selectedDeviceList,
    eventTypes: [eventSource],
    onData: onData
  }, function (loaderProps) {
    return getEventStates(loaderProps, eventSource, children);
  });
};
var MTCDataFetcher = function MTCDataFetcher(_ref) {
  var _ref$dataItemNames = _ref.dataItemNames,
    dataItemNames = _ref$dataItemNames === void 0 ? [{
      dataItemName: "auto_time"
    }] : _ref$dataItemNames,
    aggregateTypes = _ref.aggregateTypes,
    dataRange = _ref.dataRange,
    onData = _ref.onData,
    children = _ref.children,
    aggregated = _ref.aggregated,
    pagination = _ref.pagination;
  var selectedDevice = _react["default"].useContext(_DeviceContext.DeviceContext);
  var reportingPeriod = _react["default"].useContext(_ReportingPeriodContext.ReportingPeriodContext);
  var selection = _react["default"].useContext(_Core.SelectionContext);
  var timePeriod = (0, _TimePeriodController.getTimePeriod)(reportingPeriod, selection, dataRange);
  if (!selectedDevice || selectedDevice.length === 0) {
    console.warn("No device selected when rendering mtc data table");
    return null;
  }

  // forcing multi reports to only use the first item as the service doesn't support multi device queries
  var query = {
    deviceUuid: Array.isArray(selectedDevice) ? selectedDevice[0].uuid : selectedDevice.uuid,
    dataItemNames: dataItemNames,
    aggregateTypes: aggregateTypes,
    interval: timePeriod.interval
  };
  return /*#__PURE__*/_react["default"].createElement(_DeviceMTCDataQueryController.DeviceMTCDataQueryController, {
    query: query,
    onData: onData,
    aggregated: aggregated,
    pagination: pagination
  }, function (_ref2) {
    var error = _ref2.error,
      data = _ref2.data,
      reload = _ref2.reload,
      fetching = _ref2.fetching,
      pagination = _ref2.pagination;
    return children({
      content: data && data[0] ? data[0] : [],
      fetching: fetching,
      reload: reload,
      serverPagination: pagination || DEFAULT_PAGINATION_OBJECT,
      error: error
    });
  });
};
var DataTableDataProvider = exports.DataTableDataProvider = function DataTableDataProvider(props) {
  var left = props.x,
    top = props.y,
    width = props.width,
    height = props.height,
    dataRange = props.dataRange,
    eventSource = props.eventSource,
    pagination = props.pagination,
    dataItemNames = props.dataItemNames,
    aggregateTypes = props.aggregateTypes,
    onData = props.onData,
    children = props.children;
  var style = {
    top: top,
    left: left,
    width: width,
    height: height
  };
  if (eventSource === "MTC" || eventSource === "metricMTC") {
    return /*#__PURE__*/_react["default"].createElement(MTCDataFetcher, {
      dataRange: dataRange,
      style: style,
      dataItemNames: dataItemNames,
      aggregateTypes: aggregateTypes,
      onData: onData,
      aggregated: eventSource === "metricMTC",
      pagination: pagination
    }, children);
  }
  return /*#__PURE__*/_react["default"].createElement(EventDataFetcher, {
    dataRange: dataRange,
    eventSource: eventSource,
    style: style,
    pagination: pagination,
    onData: onData
  }, children);
};